// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18Apx{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));grid-gap:16px;gap:16px;grid-gap:1rem;gap:1rem}@media(max-width:767px){._18Apx{grid-template-columns:minmax(0,1fr)}}.kPZIi{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;width:100%;padding:1rem}._2lGx5{background-color:#fff;width:100%;border:1px solid #0373f9;border-radius:.25rem;-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1);-o-transition:all .3s cubic-bezier(.645,.045,.355,1);transition:all .3s cubic-bezier(.645,.045,.355,1)}._2lGx5:hover{background-color:#f7f8f8}._2lGx5 ._1KUIu{-ms-flex:1 1;flex:1 1;display:block;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis}._2lGx5 ._1rxGA{display:inline-block;margin-right:.5rem}._2lGx5 ._1rxGA path[fill]{fill:#0373f9}._2lGx5._3zCJT{background-color:#dcdddd;border:none}._2lGx5._3zCJT path[fill]{fill:#fff}._2lGx5._3zCJT .kPZIi{color:#fff;pointer-events:none}._2lGx5._3zCJT:hover{cursor:no-drop}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_18Apx",
	"wrapper": "kPZIi",
	"materialButton": "_2lGx5",
	"materialName": "_1KUIu",
	"icon": "_1rxGA",
	"disable": "_3zCJT"
};
module.exports = exports;
